import React, { HTMLAttributes } from 'react';
import InputWrapper from '../wrapper/InputWrapper';
import {
  IFieldProps,
  IInputProps,
} from 'types/components/inputs/input.interface';
import './InputField.scss';

const InputField = ({ className = '', appBackground = false, ...props }: IFieldProps) => {
  return (
    <InputWrapper
      {...(props as IInputProps)}
      render={inputProps => (
        <textarea
          {...props}
          {...(inputProps as HTMLAttributes<HTMLTextAreaElement>)}
          className={`input-field ${className} ${appBackground ? 'appBackground' : ''}`}
        />
      )}
    />
  );
};

export default InputField;
